import React, { useState } from 'react';
import { alterarSenha, salvarConta } from '../../services/api';
import styles from './AlterarSenha.module.css';

export default function AlterarSenha() {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [status, setStatus] = useState({ tipo: '', mensagem: '' });
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (senhaNova !== confirmarSenha) {
      setStatus({ tipo: 'erro', mensagem: 'As senhas nao coincidem.' });
      return;
    }

    if (senhaNova.length < 8) {
      setStatus({ tipo: 'erro', mensagem: 'A nova senha deve ter ao menos 8 caracteres.' });
      return;
    }

    setEnviando(true);
    setStatus({ tipo: '', mensagem: '' });

    try {
      const resultado = await alterarSenha(senhaAtual, senhaNova);
      if (resultado.conta) {
        salvarConta(resultado.conta);
      }
      setStatus({ tipo: 'sucesso', mensagem: 'Senha alterada com sucesso.' });
      setSenhaAtual('');
      setSenhaNova('');
      setConfirmarSenha('');
    } catch (err) {
      setStatus({ tipo: 'erro', mensagem: err.message || 'Erro ao alterar senha.' });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <section className={`${styles.container} ui-surface`}>
      <h2>Alterar Senha</h2>
      <p className={styles.subtitulo}>Informe sua senha atual e escolha uma nova senha.</p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <label>Senha atual *</label>
        <input
          className="ui-input"
          type="password"
          value={senhaAtual}
          onChange={(e) => setSenhaAtual(e.target.value)}
          required
          autoComplete="current-password"
        />

        <label>Nova senha *</label>
        <input
          className="ui-input"
          type="password"
          value={senhaNova}
          onChange={(e) => setSenhaNova(e.target.value)}
          required
          minLength={8}
          autoComplete="new-password"
        />

        <label>Confirmar nova senha *</label>
        <input
          className="ui-input"
          type="password"
          value={confirmarSenha}
          onChange={(e) => setConfirmarSenha(e.target.value)}
          required
          minLength={8}
          autoComplete="new-password"
        />

        {status.mensagem && (
          <p className={status.tipo === 'sucesso' ? styles.sucesso : styles.erro}>
            {status.mensagem}
          </p>
        )}

        <button className="ui-button-primary" type="submit" disabled={enviando}>
          {enviando ? 'Salvando...' : 'Alterar Senha'}
        </button>
      </form>
    </section>
  );
}
